<template>
  <img
    :src="iconPath"
    :alt="brand || 'Credit Card'"
    :class="computedClass"
  />
</template>

<script>
import { getCardBrandIconPath } from '@/helpers/cardBrandUtils';

export default {
  name: 'CardBrandIcon',
  props: {
    brand: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value),
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconPath() {
      return getCardBrandIconPath(this.brand);
    },
    computedClass() {
      const sizeClasses = {
        sm: 'w-6 h-6',
        md: 'w-8 h-8',
        lg: 'w-[71px] h-[40px]',
      };
      return `${sizeClasses[this.size]} object-cover ${this.customClass}`.trim();
    },
  },
};
</script>
